import React, { useState, useEffect, ChangeEvent, useCallback, FormEvent } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import SiteWrapper from "../../base/SiteWrapper";
import ProductCategory from '../../interfaces/ProductCategory';

import {
  Page,
  Button,
  Form,
  Card,
  Icon
} from "tabler-react";
import { ApiFidegg } from "../../services/apiFideggAdmin";
import Params from "../../interfaces/Params";
import { Alerta } from "../../utils/Alerta";

function ProductsForm() {

  const history = useHistory();

  const { id } = useParams<Params>();

  const initialValues: ProductCategory = {
    id: "",
    description: "",
    product_category_platform_id: "",
    value: 0,
  };

  const [productCategory, setProductCategory] = useState<ProductCategory>(initialValues);

  useEffect(() => {
    (async () => {
      if(!!id) {
        const response = await ApiFidegg.get(`productcategories/${id}`);
        if (response.status === 200) {
          setProductCategory(response.data);
        }
      }
    })();
  }, [id]);

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    setProductCategory({...productCategory, [name]: value});
  }

  function handleClickCancel(event: FormEvent) {
    event.preventDefault();
    history.goBack();
  }

  const handleSubmit = useCallback(
    async (event: FormEvent) => {
      try {
        event.preventDefault();

        const data = {
          description: productCategory.description,
          product_category_platform_id: productCategory.product_category_platform_id,
          value: productCategory.value,
        }

        if(!!productCategory.id) {
          await ApiFidegg.put(`productcategories/${productCategory.id}`, data)
          Alerta('Configuração de categoria atualizada!', 'success');
        } else {
          await ApiFidegg.post('productcategories', data)
          Alerta('Configuração de categoria incluída!', 'success');
        }

        history.push('/productcategories');
      } catch (err) {
        if(!!productCategory.id) {
          Alerta('Erro ao atualizar a configuração!');
        } else {
          Alerta('Erro ao cadastrar a configuração!');
        }
      }
    }, [history, productCategory]
  );

  return (
    <SiteWrapper>
      <Form onSubmit={handleSubmit}>
        <Page.Card
          title="Categorias de Produto"
          footer={
            <Card.Footer>
              <div className="d-flex">
                <Button link onClick={handleClickCancel} >Cancelar</Button>
                <Button type="submit" color="primary" className="ml-auto">
                  Salvar
                </Button>
              </div>
            </Card.Footer>
          }
        >
          <Form.FieldSet>
            <Form.Group label="Descrição">
              <Form.Input
                name="description"
                value={productCategory.description || ""}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>
                ID da categoria na plataforma
                <Icon name="help-circle" style={{marginLeft:'5px'}} title="ID da categoria na sua plataforma de e-commerce" />
              </Form.Label>
              <Form.Input
                name="product_category_platform_id"
                value={productCategory.product_category_platform_id || ""}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>
                Valor
              </Form.Label>
              <Form.Input
                name="value"
                value={productCategory.value || ""}
                onChange={handleChange}
                type="number"
              />
            </Form.Group>
          </Form.FieldSet>
        </Page.Card>
      </Form>
    </SiteWrapper>
  );
}

export default ProductsForm;